import { useKeycloak } from "@react-keycloak/web";
import { Button, Form, Input, Select, TableProps } from "antd";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import Loader from "../../../../components/ui/Loader";
import { useGetAllAssignProjectQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useAssignUserToProjectRoleMutation,
  useCreateUserPoolMutation,
  useGetAllProductQuery,
  useGetAllRoleQuery,
  useGetProjectsByUserQuery,
  useUserProductQuery,
} from "../../../../features/portal/Products/productsApi";
import { useGetSingleUserQuery } from "../../../../features/portal/user/userApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { GetProjectsByUserDataType } from "../../../../types/portal/product";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";
import UserPollDeleteModal from "./UserPollDeleteModal";
import UserProductAccessModal from "./UserProductAccessModal";

export default function UserPermission() {
  const statusClasses: Record<string, string> = {
    active: "bg-green-100 text-green-700",
    inactive: "bg-red-100 text-red-700",
    invited: "bg-yellow-100 text-yellow-700",
  };

  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(
    null
  );
  const [selectedProjectService, setSelectedProjectService] = useState("");
  const [selectCluster, setSelectCluster] = useState<string | null>(null);
  const [selectRegion, setSelectRegion] = useState("");
  const [selectArea, setSelectArea] = useState("");
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const { keycloak } = useKeycloak();
  const [formType, setFormType] = useState<"pool" | "role" | null>(null);
  const [form] = Form.useForm();
  const { id } = useParams();
  const { name } = useParams();
  const { page, limit, handlePagination, handleLimit } = useTable();
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");
  const { user } = useAppSelector((state) => state.auth);
  const { isError, error, isLoading, data } = useGetProjectsByUserQuery({
    params: {
      userid: id,
    },
  });

  // console.log("data", data);
  const {
    isError: isAllRoleError,
    error: allRoleError,
    data: allRoleData,
  } = useGetAllRoleQuery({
    params: {
      projectId: selectedProjectId,
    },
  });
  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      page: 1,
      limit: 1000000,
    },
  });
  const {
    isError: isUserProductError,
    error: userProductError,
    data: userProducts,
  } = useUserProductQuery({
    params: {
      page: 1,
      limit: 1000000,
    },
  });
  const [
    assignUserToProjectRole,
    {
      isError: isAssignRoleError,
      error: assignRoleError,
      isLoading: isAssignRoleLoading,
      isSuccess: isAssignRoleSuccess,
    },
  ] = useAssignUserToProjectRoleMutation();
  const [
    createUserPool,
    {
      isError: isCreatePoolError,
      error: createPollError,
      isLoading: isCreatePoolLoading,
      isSuccess: isCreatePoolSuccess,
    },
  ] = useCreateUserPoolMutation();
  const {
    isLoading: isDetailsLoading,
    isError: isDetailsError,
    error: detailsError,
    data: detailsData,
  } = useGetSingleUserQuery(id || "", {
    skip: !id,
  });

  const companyId = detailsData?.data?.company_id
    ? Number(detailsData?.data?.company_id)
    : undefined;

  const {
    isError: getAllAssignProjectIsError,
    error: getAllAssignProjectError,
    isLoading: getAllAssignProjectIsLoading,
    data: getAllAssignProject,
  } = useGetAllAssignProjectQuery(
    { id: companyId as number, search: undefined },
    {
      skip: !companyId, // only run when companyId exists
    }
  );

  // const {
  //   data: getAllPGVendorData,
  //   isLoading: getAllPGVendorIsLoading,
  //   isError: getAllPGVendorIsError,
  //   error: getAllPGVendorError,
  // } = useGetAllPGVendorQuery({});

  // const {
  //   data: getAllPGRegionData,
  //   isLoading: getAllPGRegionIsLoading,
  //   isError: getAllPGRegionIsError,
  //   error: getAllPGRegionError,
  // } = useGetAllPGRegionQuery({});

  // const {
  //   data: getAllPGAreaData,
  //   isLoading: getAllPGAreaIsLoading,
  //   isError: getAllPGAreaIsError,
  //   error: getAllPGAreaError,
  // } = useGetAllPGAreaQuery({
  //   params: {
  //     region: selectRegion,
  //   },
  // });

  // const {
  //   data: getAllPGTerritoriesData,
  //   isLoading: getAllPGTerritoriesIsLoading,
  //   isError: getAllPGTerritoriesIsError,
  //   error: getAllPGTerritoriesError,
  // } = useGetAllPGTerritoriesQuery({
  //   params: {
  //     area: selectArea,
  //   },
  // });

  useError(isError, error, "Get all  project under user fail");
  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isAllRoleError, allRoleError, "Get all role fail");
  useError(isAssignRoleError, assignRoleError, "User Role Assign fail");
  useError(isCreatePoolError, createPollError, "User Pool Assign fail");
  useError(isUserProductError, userProductError, "User project fail");
  useError(isDetailsError, detailsError, "User details get fail");
  useError(
    getAllAssignProjectIsError,
    getAllAssignProjectError,
    "User details get fail"
  );
  // useError(getAllPGVendorIsError, getAllPGVendorError, "Get vendors data fail");
  // useError(getAllPGRegionIsError, getAllPGRegionError, "Get region data fail");
  // useError(getAllPGAreaIsError, getAllPGAreaError, "Get area data fail");
  // useError(
  //   getAllPGTerritoriesIsError,
  //   getAllPGTerritoriesError,
  //   "Get territories data fail"
  // );

  const allProduct = getAllProduct?.data?.data;
  const userProduct = userProducts?.data?.data;
  const allsRollData = allRoleData?.data?.data;
  const projectId = Form.useWatch("projectId", form);
  const roleId = Form.useWatch("roleId", form);
  const poolName = Form.useWatch("poolName", form);
  const isSubmitDisabledPool = !projectId || !roleId || !poolName;
  const isSubmitDisabledRole = !projectId || !roleId;
  const projectData = getAllAssignProject?.data?.projects;

  const [projectList, setProjectList] = useState<any>([]);
  const { open, handleOpen, handleClose } = useModal<string, any>();
  const {
    open: productActivityOpen,
    handleOpen: handleProductActivityOpen,
    handleClose: handleProductActivityClose,
  } = useModal<string, any>();

  useEffect(() => {
    if (isAdmin2) {
      setProjectList(
        userProduct?.map((project: any) => ({
          label: project?.name,
          value: project?.id,
        }))
      );
    } else {
      setProjectList(
        allProduct?.map((project: any) => ({
          label: project?.name,
          value: project?.id,
        }))
      );
    }
  }, [allProduct, isAdmin2, userProduct]);

  // console.log("userProduct", userProduct);
  // console.log("allProduct", allProduct);

  const onFinishRole = (values: any) => {
    const newData = {
      ...values,
      userId: Number(id),
    };

    // const newDataPG = {
    //   userId: Number(id),
    //   roleId: values?.roleId,
    //   projectId: values?.projectId,
    //   pgUserData: {
    //     area: values?.area,
    //     email: values?.email,
    //     employeeId: values?.employeeId,
    //     nid: values?.nid,
    //     phoneNumber: values?.phoneNumber,
    //     region: values?.region,
    //     suppler: values?.suppler,
    //     teritory: values?.teritory,
    //     regionName:
    //       getAllPGRegionData?.data?.find((el) => el?._id === values?.region)
    //         ?.regionName || "",
    //     areaName:
    //       getAllPGAreaData?.data?.find((el) => el?._id === values?.area)
    //         ?.areaName || "",
    //     teritoryName:
    //       getAllPGTerritoriesData?.data?.find(
    //         (el) => el?._id === values?.teritory
    //       )?.teritoryName || "",
    //     lattitude: 23.7055748,
    //     longitude: 90.3621026,
    //     location: {
    //       type: "Point",
    //       coordinates: [90.3621026, 23.7055748],
    //     },
    //   },
    // };

    if (selectedProjectService === "power_genie") {
      // assignUserToProjectRole(newDataPG);
      // console.log("newData:", newDataPG);
    } else {
      assignUserToProjectRole(newData);
      // console.log("newData:", newData);
    }
  };

  const onFinishPool = (values: any) => {
    const newData = {
      ...values,
      userId: Number(id),
      companyId: user?.data?.company_id,
    };

    createUserPool(newData);
  };

  useEffect(() => {
    if (isAssignRoleSuccess) {
      form.resetFields();
      setFormType(null);
      toast("success", "Successfully user role assign");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAssignRoleSuccess]);

  useEffect(() => {
    if (isCreatePoolSuccess) {
      form.resetFields();
      setFormType(null);
      toast("success", "Successfully user pool assign");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreatePoolSuccess]);

  // useEffect(() => {
  //   if (id && detailsData?.data) {
  //     form.setFieldsValue({
  //       email: detailsData?.data?.email,
  //     });
  //   }
  // }, [id, detailsData?.data, form]);

  // useEffect(() => {
  //   if (allsRollData?.length) {
  //     const approverRole = allsRollData.find(
  //       (role: any) => role?.roleName === "Approver"
  //     );
  //     if (approverRole) {
  //       form.setFieldsValue({ roleId: approverRole.id });
  //     }
  //   }
  // }, [allsRollData, form]);

  const columns: TableProps<GetProjectsByUserDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Project Name",
      dataIndex: "project",
      render: (val) => (val ? val?.name : "N/A"),
    },

    {
      title: "Role Type",
      dataIndex: "role",
      align: "center",
      render: (val) => {
        let label = val?.roleName;

        if (!label) return "N/A";

        if (label === "edatco") {
          label = "Admin";
        } else if (label === "region") {
          label = "Zonal";
        } else if (label?.length <= 3) {
          label = label?.toUpperCase();
        } else {
          label = capitalize(label);
        }
        return label;
      },
    },
    {
      title: "Pool Type",
      dataIndex: "pool",
      align: "center",
      render: (val) => (val ? val?.poolName : "N/A"),
    },
    {
      title: "Redirect URL",
      dataIndex: "project",
      render: (val: any) =>
        val?.redirectUri ? (
          <a href={val.redirectUri} target="_blank" rel="noopener noreferrer">
            {val.redirectUri}
          </a>
        ) : (
          "N/A"
        ),
    },
    {
      title: <div className="whitespace-nowrap">Digigo access</div>,
      dataIndex: "role",
      align: "center",
      render: (val: { status: "active" | "inactive" | string }) => {
        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              statusClasses[val?.status] || "bg-yellow-100 text-yellow-700"
            }`}
          >
            {capitalize(val?.status)}
          </span>
        );
      },
    },
    {
      title: <div className="whitespace-nowrap">Login status</div>,
      align: "center",
      render: () => {
        const loginStatus = detailsData?.data?.status;
        const loginStatusClass = loginStatus
          ? statusClasses[loginStatus]
          : undefined;

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              loginStatusClass || "bg-yellow-100 text-yellow-700"
            }`}
          >
            {loginStatus ? capitalize(loginStatus) : "N/A"}
          </span>
        );
      },
    },

    // {
    //   title: "Actions",
    //   align: "center",
    //   render: (record) => (
    //     <div className="flex justify-center items-center gap-2">
    //       {/* <Tooltip title="Edit Role Status">
    //         <Button
    //           onClick={() =>
    //             handleProductActivityOpen({
    //               type: "PRODUCT_ACTIVITY",
    //               data: record,
    //             })
    //           }
    //           className="action-button"
    //           size="small"
    //           icon={<EditIcon />}
    //         />
    //       </Tooltip> */}

    //       {record?.pool?.poolName ? (
    //         <Tooltip title="Pool Remove">
    //           <Button
    //             onClick={() =>
    //               handleOpen({
    //                 type: "UPDATE",
    //                 data: record,
    //               })
    //             }
    //             className="action-button"
    //             size="small"
    //             icon={<DeleteIcon />}
    //           />
    //         </Tooltip>
    //       ) : (
    //         <Tooltip title="Pool Remove">
    //           <Button
    //             className="action-button"
    //             size="small"
    //             icon={<DeleteIcon />}
    //           />
    //         </Tooltip>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  if (isLoading || isDetailsLoading) {
    return <Loader />;
  }

  return (
    <>
      {open?.type === "UPDATE" && (
        <UserPollDeleteModal
          title=""
          subTitle=""
          buttonName="Send"
          open={open?.open}
          data={open?.data}
          handleClose={handleClose}
          action
          buttonBgDeep
          loading={isLoading}
        />
      )}

      {productActivityOpen?.type === "PRODUCT_ACTIVITY" && (
        <UserProductAccessModal
          title=""
          subTitle=""
          buttonName="Send"
          open={productActivityOpen?.open}
          data={productActivityOpen?.data}
          handleClose={handleProductActivityClose}
          action
          buttonBgDeep
          loading={isLoading}
          id={id}
          name={name}
        />
      )}

      <SidebarLayout
        title="User List Details & Permission Access"
        backLink="/admin/users-roll-access/user-list"
      >
        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={1}
          dataSource={addKeyInArray(data?.data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              {/* <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ width: 220 }}
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectStringOption(["Active", "Inactive"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            /> */}

              {/* <Button
                type="primary"
                className="middle-button"
                icon={<AddIcon />}
                onClick={() => setFormType("role")}
              >
                Role Assign
              </Button> */}

              {/* <Button
                type="primary"
                className="middle-button"
                icon={<AddIcon />}
                onClick={() => setFormType("pool")}
              >
                Pool Assign
              </Button> */}
            </>
          }
        />

        {formType === "pool" && (
          <div className="mt-6">
            <Form
              name="form_item_path"
              className="custom-form bg-white border border-extra-light border-solid rounded-md"
              layout="vertical"
              onFinish={onFinishPool}
              requiredMark="optional"
              size="large"
              form={form}
            >
              <div className="p-6">
                <div className="w-full mt-4 px-3 py-1.5 bg-[#f0f3f8] rounded-md justify-between items-center flex">
                  <div className="justify-start items-center gap-4 flex">
                    <div className="text-display-body text-lg font-semibold leading-[30px]">
                      Select Products & Assign User Pool
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-6 mt-4">
                  <Form.Item
                    label="Select Project"
                    name="projectId"
                    rules={[
                      { required: true, message: "Please select project" },
                    ]}
                  >
                    <Select
                      placeholder="Select Project"
                      options={projectList}
                      onChange={(value) => setSelectedProjectId(value)}
                      className="w-full"
                      suffixIcon={<SelectDownIcon />}
                      style={{ width: "100%" }}
                      allowClear
                    />
                  </Form.Item>

                  {/* <Form.Item
                    label="Select Role"
                    name="roleId"
                    initialValue={
                      allsRollData?.find(
                        (role: any) => role?.roleName === "Approver"
                      )?.id
                    }
                    rules={[{ required: true, message: "Please select role" }]}
                  >
                    <Select
                      placeholder="Select Role"
                      options={
                        allsRollData?.map((role: any) => ({
                          label: role?.roleName,
                          value: role?.id,
                        })) || []
                      }
                      className="w-full"
                      suffixIcon={<SelectDownIcon />}
                      style={{ width: "100%" }}
                      allowClear
                      disabled
                    />
                  </Form.Item> */}

                  <Form.Item
                    label="Select Role"
                    name="roleId"
                    rules={[{ required: true, message: "Please select role" }]}
                  >
                    <Select
                      placeholder="Select Role"
                      options={
                        allsRollData?.map((role: any) => ({
                          label: role?.roleName,
                          value: role?.id,
                        })) || []
                      }
                      className="w-full"
                      suffixIcon={<SelectDownIcon />}
                      style={{ width: "100%" }}
                      allowClear
                    />
                  </Form.Item>

                  <Form.Item
                    label="Select Pool"
                    name="poolName"
                    rules={[{ required: true, message: "Please select pool" }]}
                  >
                    <Select
                      placeholder="Select Pool"
                      options={[
                        { label: "Pool A", value: "Pool A" },
                        { label: "Pool B", value: "Pool B" },
                      ]}
                      className="w-full"
                      suffixIcon={<SelectDownIcon />}
                      style={{ width: "100%" }}
                      allowClear
                    />
                  </Form.Item>

                  <div>
                    <Button
                      className="modal-button max-w-[160px] pt-6 pb-6"
                      type="primary"
                      htmlType="submit"
                      size="large"
                      loading={isCreatePoolLoading}
                      disabled={isSubmitDisabledPool}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        )}

        {getAllAssignProjectIsLoading ? (
          <Loader />
        ) : (
          <>
            {formType === "role" && (
              <div className="mt-6">
                <Form
                  name="form_item_path"
                  className="custom-form bg-white border border-extra-light border-solid rounded-md"
                  layout="vertical"
                  onFinish={onFinishRole}
                  requiredMark="optional"
                  size="large"
                  form={form}
                >
                  <div className="p-6">
                    <div className="w-full mt-4 px-3 py-1.5 bg-[#f0f3f8] rounded-md justify-between items-center flex">
                      <div className="justify-start items-center gap-4 flex">
                        <div className="text-display-body text-lg font-semibold leading-[30px]">
                          Select Products & Assign User Role
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 mt-4">
                      <Form.Item
                        label="Select Project"
                        name="projectId"
                        rules={[
                          { required: true, message: "Please select project" },
                        ]}
                      >
                        <Select
                          placeholder="Select Project"
                          options={
                            projectData?.map((item: any) => ({
                              label: item?.project_name,
                              value: item?.project_id,
                            })) || []
                          }
                          onChange={(value) => {
                            setSelectedProjectId(value);
                            const selected = projectData?.find(
                              (p: any) => p.project_id === value
                            );
                            setSelectedProjectService(
                              selected?.service_name || ""
                            );
                          }}
                          className="w-full"
                          suffixIcon={<SelectDownIcon />}
                          style={{ width: "100%" }}
                          allowClear
                        />
                      </Form.Item>

                      <Form.Item
                        label="Select Role"
                        name="roleId"
                        rules={[
                          { required: true, message: "Please select role" },
                        ]}
                      >
                        <Select
                          placeholder="Select Role"
                          options={
                            allsRollData?.map((role: any) => {
                              let label = role?.roleName;

                              if (label === "edatco") {
                                label = "Admin";
                              } else if (label === "region") {
                                label = "Zonal";
                              } else if (label?.length <= 3) {
                                label = label?.toUpperCase();
                              }

                              return {
                                label,
                                value: role?.id,
                              };
                            }) || []
                          }
                          onChange={(value) => {
                            const selectedRole = allsRollData?.find(
                              (r: any) => r.id === value
                            );
                            setSelectedRoleName(selectedRole?.roleName || "");
                          }}
                          className="w-full"
                          suffixIcon={<SelectDownIcon />}
                          style={{ width: "100%" }}
                          allowClear
                        />
                      </Form.Item>

                      {/* {selectedProjectService === "power_genie" && (
                        <>
                          <Form.Item
                            name="phoneNumber"
                            label="Contact Number"
                            rules={[
                              {
                                required: true,
                                message: "Please enter contact number",
                              },
                              {
                                validator: async (_: any, value: string) => {
                                  if (!value) {
                                    return Promise.resolve();
                                  }

                                  const phoneRegex =
                                    /^(\+88)?(01[3-9])[0-9]{8}$/;
                                  if (!phoneRegex.test(value)) {
                                    return Promise.reject(
                                      new Error(
                                        "Please enter a valid Bangladeshi contact number"
                                      )
                                    );
                                  }
                                },
                              },
                            ]}
                          >
                            <Input
                              prefix={"BD "}
                              size="large"
                              placeholder="Mobile No:"
                            />
                          </Form.Item>

                          <Form.Item
                            name="employeeId"
                            label="Employee ID"
                            rules={[
                              {
                                required: true,
                                message: "Please enter employee ID",
                              },
                              {
                                validator: async (_: any, value: string) => {
                                  if (!value) return Promise.resolve();

                                  const trimmedValue = value.trim();

                                  if (/^[-_]/.test(trimmedValue)) {
                                    return Promise.reject(
                                      new Error(
                                        "Are not allowed start with '-' or '_'"
                                      )
                                    );
                                  }

                                  if (trimmedValue.includes(".")) {
                                    return Promise.reject(
                                      new Error(
                                        "Decimal points are not allowed"
                                      )
                                    );
                                  }

                                  if (/\s/.test(trimmedValue)) {
                                    return Promise.reject(
                                      new Error("Spaces are not allowed")
                                    );
                                  }

                                  if (!/^[a-zA-Z0-9_-]+$/.test(trimmedValue)) {
                                    return Promise.reject(
                                      new Error(
                                        "Only alphabets, digits, hyphens (-), and underscores (_) are allowed."
                                      )
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              placeholder="Enter Employee ID"
                            />
                          </Form.Item>

                          <Form.Item
                            name="email"
                            label="Email"
                            rules={[
                              {
                                required: true,
                                message: "Please enter email",
                              },
                              {
                                validator: async (_: any, value: string) => {
                                  if (!value) {
                                    return Promise.resolve();
                                  }

                                  const emailRegex =
                                    /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
                                  const consecutiveInvalidsRegex =
                                    /(\.\.|--|-\.)|(\.-)/;

                                  if (
                                    !emailRegex.test(value) ||
                                    consecutiveInvalidsRegex.test(value)
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        "Please enter a valid email (no repeated or mixed special characters)"
                                      )
                                    );
                                  }
                                },
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              placeholder="Enter email"
                              disabled
                            />
                          </Form.Item>

                          <Form.Item
                            name="nid"
                            label="NID"
                            rules={[
                              {
                                required: true,
                                message: "Please enter NID",
                              },
                              {
                                validator: async (_: any, value: string) => {
                                  if (!value) {
                                    return Promise.resolve();
                                  }

                                  if (!/^\d+$/.test(value)) {
                                    return Promise.reject(
                                      new Error("NID must be number")
                                    );
                                  }

                                  if (value.length < 10) {
                                    return Promise.reject(
                                      new Error(
                                        "NID should be minimum 10 digits"
                                      )
                                    );
                                  }

                                  if (value.length > 20) {
                                    return Promise.reject(
                                      new Error(
                                        "NID should not exceed 20 digits"
                                      )
                                    );
                                  }
                                },
                              },
                            ]}
                          >
                            <Input
                              className="w-full"
                              size="large"
                              placeholder="Enter NID"
                            />
                          </Form.Item>

                          <Form.Item
                            shouldUpdate={(prev, curr) =>
                              prev.roleId !== curr.roleId
                            }
                            noStyle
                          >
                            {({ getFieldValue }) => {
                              const roleId = getFieldValue("roleId");
                              const selectedRole = allsRollData?.find(
                                (r: any) => r.id === roleId
                              );
                              const isRequired =
                                selectedRole?.roleName === "Pg" ||
                                selectedRole?.roleName === "Vendor";

                              return (
                                <Form.Item
                                  name="suppler"
                                  label="Select Vendor"
                                  rules={
                                    isRequired
                                      ? [
                                          {
                                            required: true,
                                            message: "Please select vendor",
                                          },
                                        ]
                                      : []
                                  }
                                >
                                  <Select
                                    placeholder="Select Vendor"
                                    size="large"
                                    allowClear
                                    showSearch
                                    options={
                                      getAllPGVendorData?.data?.map(
                                        (vendor) => ({
                                          label: vendor.supplierName,
                                          value: vendor._id,
                                        })
                                      ) || []
                                    }
                                    filterOption={(input, option) =>
                                      (option?.label as string)
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    onChange={(vendorId) => {
                                      const vendor =
                                        getAllPGVendorData?.data?.find(
                                          (v) => v._id === vendorId
                                        );
                                      if (vendor?.region?._id) {
                                        setSelectCluster(vendor.region._id);
                                        setSelectRegion(vendor.region._id);
                                        form.setFieldValue(
                                          "region",
                                          vendor.region._id
                                        );
                                      } else {
                                        setSelectCluster(null);
                                        form.setFieldValue("region", undefined);
                                      }
                                    }}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>

                          <Form.Item
                            name="region"
                            label="Select Cluster"
                            rules={[
                              {
                                required: true,
                                message: "Please select cluster",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select cluster"
                              size="large"
                              allowClear
                              showSearch
                              options={
                                getAllPGRegionData?.data?.map((region) => ({
                                  label: capitalize(region.regionName),
                                  value: region._id,
                                })) || []
                              }
                              filterOption={(input, option) =>
                                (option?.label as string)
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              onChange={(val) => {
                                setSelectRegion(val);
                                setSelectArea("");
                                form.setFieldValue("area", undefined);
                                form.setFieldValue("teritory", undefined);
                              }}
                              disabled={!!selectCluster}
                            />
                          </Form.Item>

                          <Form.Item
                            name="area"
                            label="Select Zonal"
                            rules={[
                              {
                                required: true,
                                message: "Please select zonal",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Zonal"
                              size="large"
                              allowClear
                              showSearch
                              options={getAllPGAreaData?.data?.map(
                                (area: any) => ({
                                  label: capitalize(area.areaName),
                                  value: area._id,
                                })
                              )}
                              onChange={(val) => {
                                setSelectArea(val);
                                form.setFieldValue("teritory", undefined);
                              }}
                              disabled={!selectRegion}
                              loading={getAllPGAreaIsLoading}
                            />
                          </Form.Item>

                          <Form.Item
                            name="teritory"
                            label="Select Territory"
                            rules={[
                              {
                                required: true,
                                message: "Please select territory",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select territory"
                              size="large"
                              allowClear
                              showSearch
                              options={getAllPGTerritoriesData?.data?.map(
                                (territory: any) => ({
                                  label: capitalize(territory.teritoryName),
                                  value: territory._id,
                                })
                              )}
                              disabled={!selectArea}
                              loading={getAllPGTerritoriesIsLoading}
                            />
                          </Form.Item>
                        </>
                      )}    */}

                      <div className="mt-6">
                        <Button
                          className="modal-button max-w-[160px] pt-6 pb-6"
                          type="primary"
                          htmlType="submit"
                          size="large"
                          loading={isAssignRoleLoading}
                          disabled={isSubmitDisabledRole}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            )}
          </>
        )}
      </SidebarLayout>
    </>
  );
}
